import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedSeccionturismos,
  addingSeccionturismos,
  addingSeccionturismosFailed,
  editedSeccionturismos,
  editingSeccionturismos,
  editingSeccionturismosFailed,
  foundSeccionturismos,
  loadedSeccionturismos,
  loadingSeccionturismos,
  loadingSeccionturismosFailed,
  removedSeccionturismo,
  removingSeccionturismo,
  removingSeccionturismoFailed,
  searchingSeccionturismos,
  searchingSeccionturismosFailed,
  SeccionturismosAction,
  SeccionturismosActionTypes,
  softRemovedSeccionturismos,
  softRemovingSeccionturismos,
  softRemovingSeccionturismosFailed,
} from '../actions/seccionturismosActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchSeccionturismosEpic: Epic<SeccionturismosAction, SeccionturismosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionturismosActionTypes.SEARCH_SECCIONTURISMOS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/seccionturismos/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundSeccionturismos(response.data, action.keep)),
        startWith(searchingSeccionturismos()),
        catchError(() => of(searchingSeccionturismosFailed()))
      )
    })
  )

const loadSeccionturismosEpic: Epic<SeccionturismosAction, SeccionturismosAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(SeccionturismosActionTypes.LOAD_SECCIONTURISMOS)),
    switchMap((action) => {
      let url = `${API_URL}/api/seccionturismos/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedSeccionturismos(response.data)),
        startWith(loadingSeccionturismos()),
        catchError(() => of(loadingSeccionturismosFailed()))
      )
    })
  )
}

const addSeccionturismosEpic: Epic<SeccionturismosAction, SeccionturismosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionturismosActionTypes.ADD_SECCIONTURISMOS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/seccionturismos/`, data, config)).pipe(
        map((response) => addedSeccionturismos(response.data)),
        startWith(addingSeccionturismos()),
        catchError((err) => of(addingSeccionturismosFailed(err.response)))
      )
    })
  )

const removeSeccionturismosEpic: Epic<SeccionturismosAction, SeccionturismosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionturismosActionTypes.REMOVE_SECCIONTURISMO)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionturismos/${action.payload._id}`)).pipe(
        map((response) => removedSeccionturismo()),
        startWith(removingSeccionturismo()),
        catchError(() => of(removingSeccionturismoFailed()))
      )
    )
  )

const softRemoveSeccionturismosEpic: Epic<SeccionturismosAction, SeccionturismosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionturismosActionTypes.SOFT_REMOVE_SECCIONTURISMOS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/seccionturismos/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedSeccionturismos(response.data.record)),
        startWith(softRemovingSeccionturismos()),
        catchError((err) => of(softRemovingSeccionturismosFailed(err.response)))
      )
    )
  )

const editSeccionturismosEpic: Epic<SeccionturismosAction, SeccionturismosAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(SeccionturismosActionTypes.EDIT_SECCIONTURISMOS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/seccionturismos/${action.payload._id}`, data, config)).pipe(
        map((response) => editedSeccionturismos(response.data)),
        startWith(editingSeccionturismos()),
        catchError((err) => of(editingSeccionturismosFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchSeccionturismosEpic,
  loadSeccionturismosEpic,
  addSeccionturismosEpic,
  removeSeccionturismosEpic,
  softRemoveSeccionturismosEpic,
  editSeccionturismosEpic
)
